import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import {SonergiaService} from "../services/sonergia.service";

@Injectable({
  providedIn: 'root'
})
export class sonergiaGuard  {
  constructor(
    private sonergiaService: SonergiaService,
  ) {
  }

  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {

    return this.sonergiaService.sonergiaPartner();
  }
}
